/// <amd-module name="Build/Run/Components/PipelinePermissionsErrorCard" />
import * as React from "react";

import { IPipelineResourcesService } from "Build/Common/Library/PipelineResourcesService";

import * as Resources from "Build/Run/Resources";

import { IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService";

import { VssComponent, IVssComponentContext } from "VSS/Platform/Layout";
import { format } from "VSS/Core/Util/String";

import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

interface IPipelinePermissionsErrorCardProps {
    resourceAuthErrorMessages: string;
    pipelineId: number;
    sourceBranch: string;
}

interface IPipelinePermissionsErrorCardState {
    authorizingResources: boolean;
    resourcesAuthorized: boolean;
}

export class PipelinePermissionsErrorCard extends VssComponent<IPipelinePermissionsErrorCardProps, IPipelinePermissionsErrorCardState> {
    private _pipelineResourcesService: IPipelineResourcesService;
    private _messageService: IGlobalMessagesService;

    constructor(props: IPipelinePermissionsErrorCardProps, context: IVssComponentContext) {
        super(props, context);

        this._pipelineResourcesService = this.context.pageContext.getService<IPipelineResourcesService>("IPipelineResourcesService");
        this._messageService = this.context.pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");

        this.state = {
            authorizingResources: false,
            resourcesAuthorized: false
        };
    }

    public render() {
        const resourceAuthErrorMessages: string = this.props.resourceAuthErrorMessages;

        if (resourceAuthErrorMessages) {
            const errorActions = [
                {
                    text: this.state.resourcesAuthorized ? Resources.AuthorizedResourcesButtonText : Resources.AuthorizeResourcesButtonText,
                    onClick: this._authorizeResources,
                    disabled: this.state.authorizingResources || this.state.resourcesAuthorized
                }
            ];

            const errorMessage = format(Resources.IssuesMessage,Resources.ResourceAuthIssue, resourceAuthErrorMessages)

            return (<MessageCard
                className="margin-top-16"
                severity={MessageCardSeverity.Error}
                buttonProps={errorActions}>
                <span dangerouslySetInnerHTML={{ __html: errorMessage }}/>
            </MessageCard>);
        }
        else {
            return null
        }
    }

    private _authorizeResources = () => {
        this.setState({ authorizingResources: true });

        this._pipelineResourcesService.autoAuthorizeResources(this.props.pipelineId, this.props.sourceBranch).then(() => {
            this._addToast(Resources.AuthorizeResourcesSuccessMessage);
            this.setState({ resourcesAuthorized: true });
        }, (error: Error) => {
            console.warn("Error while auto-authorizing resources: " + error && error.message);
            this._addToast(error.message || Resources.AuthorizeResourcesErrorMessage);
            this.setState({ authorizingResources: false });
        });
    }

    private _addToast(message: string) {
        this._messageService.addToast({
            message: message,
            duration: 5000,
            forceOverrideExisting: true
        });
    }
}